import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'

import { EditSurveyWizard } from 'modules/engagement_surveys/components/SurveyResourceHeader/EditSurveyWizard'

type Data = {
  surveyId: string
}

export const SurveySettingsActivity: ActivityComponent<Data> = ({ surveyId }) => {
  const { open, closeActivity } = useActivity()

  if (!open) return null

  return (
    <EditSurveyWizard
      surveyId={Number(surveyId)}
      onClose={closeActivity}
      onSuccess={closeActivity}
      action="edit"
    />
  )
}
